import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { commandeDetails } from "../actions/commandeActions";
import { listeClients } from "../actions/clientsActions";
import { useParams, useNavigate } from "react-router-dom";
import "../CommandeDetails.css";

const CommandeDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { commande, loading } = useSelector((state) => state.commandeDetails);
  const { clients } = useSelector((state) => state.clientsListeState);
  const { client } = useSelector((state) => state.client);

  useEffect(() => {
    dispatch(commandeDetails(id));
    dispatch(listeClients());
  }, [dispatch, id]);

  const nomRepFn = (cod_rep) => {
    const rep = clients.find((cli) => cli.cod_cli === cod_rep);
    return rep ? rep.nom_cli : "Pas de Representant";
  };

  return (
    <div className="container">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      )}

      <div className="content-container">
        <div className="client-info">
          <h2 className="client-info-title">Client</h2>
          <div className="client-info-row">
            <span className="client-info-label">Nom:</span>
            <span className="client-info-value">{commande?.nom_cli}</span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Solde:</span>
            <span className="client-info-value">
              {clients
                ?.find((cli) => cli.cod_cli === commande?.cod_cli)
                ?.solde?.toFixed(3)}
            </span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Adresse:</span>
            <span className="client-info-value">
              {commande?.livraisonAdresse?.adresse}
            </span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Date Liv:</span>
            <span className="client-info-value">
              {commande?.date_livraison?.substring(0, 10)}
            </span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Totale:</span>
            <span className="client-info-value">
              {commande?.totalePrix?.toFixed(3)}
            </span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Réprésentant:</span>
            <span className="client-info-value">
              {nomRepFn(commande?.cod_rep)}
            </span>
          </div>
        </div>

        <div className="articles-container">
          <h3 className="section-title">Articles Commandées</h3>
          <div className="articles-header">
            <span className="articles-header-text">Article</span>
            <span className="articles-header-text">Puv</span>
            <span className="articles-header-text">Qte</span>
          </div>
          <div className="articles-list">
            {commande?.chariotListe?.map((item, i) => (
              <div
                key={i}
                className="article-item"
                onClick={() => navigate(`/article-details/${item.article}`)}
              >
                <img
                  src={`https://gestpro.globalsystempro.com${item.image}`}
                  alt={item.nom}
                  className="article-image"
                />
                <span className="article-name">{item?.nom}</span>
                <span className="article-price">{item?.prix.toFixed(3)}</span>
                <span className="article-qty">{item?.qty}</span>
              </div>
            ))}
          </div>
        </div>

        {commande?.commentaire && (
          <div className="comment-container">
            <h3 className="section-title">Commentaire</h3>
            <p className="comment-text">{commande.commentaire}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommandeDetails;
